/**
 *
 * NewTreatmentTreatmentStep
 *
 */

import { Component } from "react";
import * as PropTypes from "prop-types";
import { connect } from "react-redux";
import styled from "styled-components";
import { createStructuredSelector } from "reselect";
import { compose } from "redux";
import StepArrows from "components/MultiStep/StepArrows";
import injectReducer from "utils/injectReducer";
import GlobalMessages from "messages/messages";
import {
  createTreatmentPlanAction,
  deletePlannedTreatment,
  getTreatmentPlan,
  saveTreatments,
  setEditingTreatmentAction,
  setTreatmentToPlanAction,
  updateTreatmentPlanAction,
} from "containers/NewTreatmentPage/actions";
import TreatmentPlan from "components/TreatmentPlan/TreatmentPlan";
import { FieldWrapper } from "basicComponents/FormComponents/FormComponents";
import {
  makeSelectTreatmentLoading,
  makeSelectTreatmentPlan,
} from "containers/NewTreatmentPage/selectors";
import ModalHeader from "basicComponents/ForegroundBlobFakeModalHeader/ForegroundBlobFakeModalHeader";
import {
  makeSelectEndProductTypes,
  makeSelectEndProductTypesConfigurations,
} from "containers/App/selectors";
import { FormattedMessage, injectIntl } from "react-intl";
import NewTreatmentMessages from "containers/NewTreatmentPage/messages";
import reducer from "./reducer";
import TreatmentStepPopUp from "../TreatmentStepPopUp/TreatmentStepPopUp";
import history from "utils/history";
import PatientDataBoxNew from "components/PatientDataBox/PatientDataBoxNew";
import CustomInputComponent from "components/CustomInputComponent/CustomInputComponent";
import DocumentOrderModal from "containers/ProductQuestionFlow/DocumentOrderModal";

export class NewTreatmentTreatmentStep extends Component {
  static propTypes = {
    setTreatmentToPlan: PropTypes.func.isRequired,
    updateTreatmentPlan: PropTypes.func.isRequired,
    createTreatmentPlan: PropTypes.func.isRequired,
    onBack: PropTypes.func.isRequired,
    onNext: PropTypes.func.isRequired,
    patient: PropTypes.object.isRequired,
    endProductTypes: PropTypes.array.isRequired,
    endProductTypesConfigurations: PropTypes.array.isRequired,
    getTreatmentPlan: PropTypes.func.isRequired,
    treatmentLoading: PropTypes.bool.isRequired,
    treatmentPlan: PropTypes.object,
    saveTreatments: PropTypes.func.isRequired,
    deletePlannedTreatment: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    shouldShowUserStep: PropTypes.bool,
    insurers: PropTypes.array.isRequired,
    dentists: PropTypes.array.isRequired,
    intl: PropTypes.object.isRequired,
    setEditing: PropTypes.func.isRequired,
  };

  state = {
    practitioner: "",
    description: "",

    endProductError: false,
    nextClicked: false,

    // End product
    plannedTreatments: [],
    endProductTypeConfigurationId: -1,
    upperProductTypesId: null,
    lowerProductTypesId: null,
    upperIndex: -1,
    lowerIndex: -1,
    upperImplantCount: 0,
    lowerImplantCount: 0,

    // Active treatment
    activeTreatment: null,
    activeIndex: -1,

    showPopUp: false,

    // For handling extra treatment Item, name can be changed
    wagnerItem: null,
    wagnerActive: false,

    isExitWarningModalOpen: false,
    goToRefittingTreatment: false,
  };

  parseTreatmentPlan(treatmentPlan) {
    const plannedTreatments = treatmentPlan.plannedTreatments.slice();
    const endProducts = this.props.endProductTypesConfigurations.slice();
    const { endProductTypeConfigurationId } = treatmentPlan;

    // Get the correct end product for the treatmentPlan
    const endProductIndex = endProducts.findIndex(
      endProduct => endProduct.id === endProductTypeConfigurationId,
    );
    const endProduct = endProducts[endProductIndex];

    // Get the wagner treatment, if it exists.
    // optional item moet in deze lijst staan
    const wagnerItem = endProduct.treatments.find(a => a.id === 24 || a.id == 12 || a.id == 31);
    // Combine the planned treatment with the end product treatments.
    const combinedTreatments = this.combineTreatments(
      plannedTreatments,
      endProducts[endProductIndex].treatments.slice(),
    );
    // Get the active treatment.
    const { activeIndex, activeTreatment } = this.findActive(
      combinedTreatments.filter(t => t.duration > 0 && t.active === true),
    );

    const loaded = plannedTreatments.find(a => a.active === false);

    // checks for plannedTreatments which are active to handle the first time load
    if (!loaded) {
      this.setState({ wagnerActive: true });
    }

    // eslint-disable-next-line react/no-did-update-set-state
    this.setState({
      endProductTypeConfigurationId,
      lowerIndex: endProduct.lowerEndProductTypeId,
      upperIndex: endProduct.upperEndProductTypeId,
      upperProductTypesId: endProduct.upperEndProductTypeId,
      lowerProductTypesId: endProduct.lowerEndProductTypeId,
      practitioner: treatmentPlan.name,
      description: treatmentPlan.description,
      upperImplantCount: treatmentPlan.upperImplantCount,
      lowerImplantCount: treatmentPlan.lowerImplantCount,
      plannedTreatments: combinedTreatments,
      activeIndex,
      wagnerItem,
      activeTreatment:
        history.location.activeTreatment ||
        history.location.state?.activeTreatment ||
        activeTreatment,
    });
  }

  componentDidMount() {
    window.currentNewTreatmentTreatmentStep = this
    if (!this.props.treatmentPlan) {
      this.props.getTreatmentPlan(this.props.patient.id);
    } else {
      this.parseTreatmentPlan(this.props.treatmentPlan);
    }

    //queryselector to see which row is selected
    //if right row is not selected click on next and repeat
    //if it is selected click on volgende button
    var url = new URL(window.location.href);
    var plannedtreatmentid = url.searchParams.get("plannedtreatmentid");

    if(plannedtreatmentid == null){
      // history.push(`/patient/${this.props.patient.id}`)
    }

    function checkrow(){
      var currentskipbtn = document.querySelector(".skipbtn")
      var rowdata = document.querySelectorAll('span[paultag="rowinfo"]')
      rowdata = Array.from(rowdata)
      var activerow = rowdata.find(row => row.getAttribute("isdisabled") == "false")

      if(plannedtreatmentid == activerow.innerHTML){
        document.querySelector(".nextbtn").click()
      }else{
        var skipbtn = document.querySelector(".skipbtn")
        if(skipbtn != null){
          skipbtn.click()
          setTimeout(checkrow, 100);
        }else{
          try {
            document.querySelector(".extratreatmentbtn").click()
          } catch (error) {
            
          }
          try {
            document.querySelector("#confirmButton").click()
          } catch (error) {
            
          }
          try {
            //prev row
            document.querySelector(".prevbtn").click()
          } catch (error) {
            
          }

          //next page
          document.querySelector(".nextbtn").click()
        }
      }
    }

    setTimeout(() => {
      checkrow()
    }, 1000);

  }

  combineTreatments(plannedTreatments, types) {
    return plannedTreatments.map(plannedTreatment => {
      const typeIndex = types.findIndex(
        e => e.id === plannedTreatment.treatmentId,
      );
      const type = types[typeIndex];
      return {
        ...plannedTreatment,
        ...type,
        id: plannedTreatment.id,
        order: plannedTreatment.order,
        active: plannedTreatment.active,
      };
    });
  }

  componentDidUpdate(prevProps) {
    const { treatmentPlan } = this.props;
    // ProductPlan has loaded, ready to edit
    if (prevProps.treatmentLoading && !this.props.treatmentLoading) {
      // If we have a treatmentPlan, edit it
      if (treatmentPlan) {
        this.parseTreatmentPlan(treatmentPlan);
      }

      if (treatmentPlan && this.props?.reFittingPlannedTreatment?.id > 0) {
        this.setState({
          goToRefittingTreatment: true,
          activeTreatment: this.props?.reFittingPlannedTreatment,
          activeIndex: treatmentPlan.plannedTreatments.findIndex(
            pt => pt.id === this.props?.reFittingPlannedTreatment?.id,
          ),
        });
        //this.handleNextForRefitting();
      }
    }
  }

  /**
   * Based on a list of treatments determine which treatment should be active.
   * @param treatments
   * @returns {{activeIndex: number, activeTreatment: Object}}
   */
  findActive(treatments) {
    let activeIndex = 0;
    let activeTreatment = null;

    for (let i = treatments.length - 1; i >= 0; i--) {
      const current = treatments[i];
      let isNextPlanned = false;
      if (i > 0) {
        isNextPlanned = treatments[i - 1].planned;
      }

      if (isNextPlanned || current.planned) {
        activeIndex = i;
        activeTreatment = current;
        break;
      }
    }
    if (!activeTreatment && treatments.length > 0) {
      activeTreatment = treatments[0];
    }

    return { activeIndex, activeTreatment };
  }

  isNextClickable() {
    const { activeTreatment } = this.state;
    if (!activeTreatment) {
      return false;
    }
    return !this.state.nextClicked && !activeTreatment.planned;
  }

  handleActiveTreatmentChanged = (treatment, index) => {
    this.setState({
      activeTreatment: treatment,
      activeIndex: index,
    });
  };

  handleUpperImplantCountChanged = ({ value }) => {
    this.setState(s => ({
      ...s,
      upperImplantCount: value,
    }));
  };

  handleLowerImplantCountChanged = ({ value }) => {
    this.setState(s => ({
      ...s,
      lowerImplantCount: value,
    }));
  };

  handleEndProductUpper = name => {
    const index = this.getEndProductType().findIndex(
      endProd => endProd.description === name,
    );

    // If we can't find the endProduct, don't do anything.
    if (index === -1) {
      return;
    }

    // Set the upper end product
    const upperProd = this.getEndProductType()[index];
    this.setState({
      upperProductTypesId: upperProd.id,
      endProductError: false,
      upperIndex: index,
    });
    this.handleUpperAndLowerEndProduct(
      upperProd.id,
      this.state.lowerProductTypesId,
    );
  };

  handleEndProductLower = name => {
    const index = this.getEndProductType().findIndex(
      endProd => endProd.description === name,
    );

    // If we can't find the endProduct, don't do anything.
    if (index === -1) {
      return;
    }

    // Set the lower end product.
    const lowerProd = this.getEndProductType()[index];
    this.setState({
      lowerProductTypesId: lowerProd.id,
      endProductError: false,
      lowerIndex: index,
    });
    this.handleUpperAndLowerEndProduct(
      this.state.upperProductTypesId,
      lowerProd.id,
    );
  };

  handlePractitionerChanged = e => {
    this.setState({
      practitioner: e.target.value,
    });
  };

  handleDescriptionChanged = e => {
    this.setState({
      description: e.target.value,
    });
  };

  handleEditClicked = treatment => {
    this.props.setEditing(true);
    this.handleNextClicked(treatment);
  };

  handleDelete = (treatment, index, wagnerTreatment) => {
    this.props.deletePlannedTreatment(treatment, () => {
      treatment.planned = false;
      this.setState(prevState => {
        const plannedTreatments = prevState.plannedTreatments.slice();
        const order = plannedTreatments.findIndex(
          t => t.order === treatment.order,
        );
        plannedTreatments[order].planned = false;
        if (treatment.refitting) {
          plannedTreatments.splice(order, 1);
        }
        return {
          plannedTreatments,
          activeIndex: index,
          activeTreatment: wagnerTreatment || treatment,
        };
      });
    });
  };

  handleMatch = () => {
    // this has to be done in a better way.

    if (this.state.upperProductTypesId != null) {
      this.handleUpperAndLowerEndProduct(
        this.state.upperProductTypesId,
        this.state.upperProductTypesId,
      );
      this.setState({
        // matchClicked: true,
        // eslint-disable-next-line react/no-access-state-in-setstate
        lowerProductTypesId: this.state.upperProductTypesId,
        // eslint-disable-next-line react/no-access-state-in-setstate
        lowerIndex: this.state.upperIndex,
      });
    }

    if (this.state.lowerProductTypesId != null) {
      this.handleUpperAndLowerEndProduct(
        this.state.lowerProductTypesId,
        this.state.lowerProductTypesId,
      );
      this.setState({
        // matchClicked: true,
        // eslint-disable-next-line react/no-access-state-in-setstate
        upperProductTypesId: this.state.lowerProductTypesId,
        // eslint-disable-next-line react/no-access-state-in-setstate
        upperIndex: this.state.lowerIndex,
      });
    }
  };

  /**
   * Helper function for handleNextClicked
   */
  canNextContinue() {
    // Don't continue if the button was already clicked.
    if (this.state.nextClicked) {
      return false;
    }

    // We need a treatmentPlan to continue.
    if (this.state.lowerIndex === -1 || this.state.upperIndex === -1) {
      this.setState({
        endProductError: true,
      });
      return false;
    }
    return true;
  }

  handleNextForRefitting = () => {
    this.handleNextClicked(this.props.reFittingPlannedTreatment);
  };

  handleNextClicked = treatment => {
    // Check if the current state is correct.
    if (!this.canNextContinue()) return;

    // Get the treatment to plan.
    let treatmentToPlan = treatment || this.state.activeTreatment;
    if (!treatmentToPlan) {
      return;
    }

    this.setState({
      nextClicked: true,
    });

    const config = this.props.endProductTypesConfigurations.find(
      x => x.id === this.state.endProductTypeConfigurationId,
    );

    const lowerProduct = this.props.endProductTypes.find(
      x => x.id === config.lowerEndProductTypeId,
    );
    const upperProduct = this.props.endProductTypes.find(
      x => x.id === config.upperEndProductTypeId,
    );

    // build the treatment plan from the type id and other user input.
    const treatmentPlan = {
      name: this.state.practitioner,
      description: this.state.description,
      patientId: this.props.patient.id,
      endProductTypeConfigurationId: this.state.endProductTypeConfigurationId,
      lowerImplantCount: lowerProduct.implant
        ? this.state.lowerImplantCount
        : 0,
      upperImplantCount: upperProduct.implant
        ? this.state.upperImplantCount
        : 0,
    };

    // Save handler called after the treatmentPlan has been saved.
    const onSave = () => {
      if (
        this.props.treatmentPlan &&
        treatmentToPlan &&
        !treatmentToPlan?.treatmentPlanId
      ) {
        treatmentToPlan = this.props.treatmentPlan?.plannedTreatments.find(
          t => {
            return t.treatmentId === treatmentToPlan.id;
          },
        );
        const treatment =
          this.state &&
          this.state.plannedTreatments &&
          this.state.plannedTreatments.find(t => {
            return t.id === treatmentToPlan.treatmentId;
          });
        treatmentToPlan.onlyInTimeSlot = treatment && treatment.onlyInTimeSlot;
      }
      this.props.saveTreatments(this.state.plannedTreatments.slice());
      this.props.setTreatmentToPlan({
        ...treatmentToPlan,
        lowerImplantCount: treatmentPlan.lowerImplantCount || 0,
        upperImplantCount: treatmentPlan.upperImplantCount || 0,
      });
      this.props.onNext();
    };

    if (this.props.treatmentPlan) {
      // Edit existing.
      treatmentPlan.id = this.props.treatmentPlan.id;
      this.props.updateTreatmentPlan(treatmentPlan, onSave);
    } else {
      // Create new.
      this.props.createTreatmentPlan(treatmentPlan, onSave);
    }
  };

  getEndProductType() {
    const endProducts = this.props.endProductTypes.slice();

    endProducts.forEach((item, i) => {
      if (item.id === 18) {
        endProducts.splice(i, 1);
        endProducts.unshift(item);
      }
    });
    return endProducts;
  }

  /**
   * Set a lit of treatments based on the upper and lower end product.
   * @param upperId The id of the upper endProduct
   * @param lowerId The id of the lower endProduct
   */
  handleUpperAndLowerEndProduct = (upperId, lowerId) => {
    const endProduct = this.props.endProductTypesConfigurations.find(
      key =>
        key.upperEndProductTypeId === upperId &&
        key.lowerEndProductTypeId === lowerId,
    );

    if (!endProduct) {
      this.setState({
        plannedTreatments: [],
        activeIndex: -1,
        activeTreatment: null,
      });
      return;
    }

    // optional item moet in deze lijst staan
    const wagnerItem = endProduct.treatments.find(a => a.id === 24 || a.id == 12 || a.id == 31);
    const plannedTreatments = endProduct.treatments.slice();
    const sorted = plannedTreatments.sort((a, b) => a.order - b.order);
    const { activeIndex, activeTreatment } = this.findActive(plannedTreatments);

    this.setState({
      endProductError: false,
      plannedTreatments: sorted,
      activeIndex,
      activeTreatment,
      endProductTypeConfigurationId: endProduct.id,
      wagnerItem,
      wagnerActive: false,
    });
  };

  handleExtraTreatmentClick = () => {
    this.setState(({ plannedTreatments }) => {
      //de optional moet order 3 zijn
      const treatment = plannedTreatments.find(t => t.order === 3);

      plannedTreatments.forEach(pt => {
        if (pt.planned && pt.order > 2) {
          this.handleDelete(pt, 1, treatment);
        }
      });

      return {
        wagnerActive: true,
        activeTreatment: treatment,
      };
    });
  };

  handleDisableWagner = () => {
    this.setState(s => ({
      ...s,
      wagnerActive: false,
    }));
  };

  render() {
    const hasTreatment = !!this.state.activeTreatment;

    // Build the list of treatments.
    let treatments = this.state.plannedTreatments.slice();
    if (this.state.wagnerActive) {
      // iF wagnerActive we need to always include the wagner treatment
      treatments = treatments.filter(e => e.duration > 0);
    } else {
      // If the wagner is not active, we only include the wagner treatment if it is active.
      treatments = treatments.filter(e => e.duration > 0 && e.active === true);
    }

    if (this.state.goToRefittingTreatment) {
      this.handleNextForRefitting();
    }

    return (
      <>
        <DocumentOrderModal
          onClose={this.props.handleCloseModal}
          title={
            <FormattedMessage
              {...GlobalMessages.dataNotSavedModalAppointmentTitle}
            />
          }
          isOpen={this.props.showModal}
          onConfirm={this.props.onClose}
          content={
            <FormattedMessage
              {...GlobalMessages.are_you_sure_you_want_to_go_back}
            />
          }
        />
        <TreatmentStepPopUp
          visible={this.state.showPopUp}
          onClose={() => {
            this.setState({ showPopUp: false });
          }}
          treatment={this.state.activeTreatment}
        />
        <ModalHeader onClose={this.props.handleModalOpen}>
          <FormattedMessage {...NewTreatmentMessages.firstHeader} />
        </ModalHeader>
        <ContentContainer style={{position:"relative"}}>
          <div style={{backgroundColor:"#f6efe8",position:"absolute",top:"0",right:"-400px",bottom:"0",left:"-100px",zIndex:"100"}}>{window.debugMode ? "white overlay123" : ""}</div>
          <StepArrows
            leftDisabled={false}
            rightDisabled={false}
            // leftDisabled={!this.props.shouldShowUserStep}
            // rightDisabled={
            //   this.state.upperIndex < 0 || this.state.lowerIndex < 0
            // }
            // rightTransparent={!this.isNextClickable()}
            rightTransparent={false}
            onNext={this.handleNextClicked}
            onBack={this.props.onBack}
          >
            <Content>
              {this.props.patient && (
                <PatientDataBoxNew
                  patient={this.props.patient}
                  insurers={this.props.insurers}
                  dentists={this.props.dentists}
                  onClickView={() => {
                    this.setState({
                      isExitWarningModalOpen: true,
                    });
                  }}
                />
              )}
              {!this.props.treatmentLoading && (
                <FieldWrapper>
{/* treatmentplan */}
                  <TreatmentPlan
                    endProductError={this.state.endProductError}
                    onDelete={this.handleDelete}
                    upperProductTypes={this.getEndProductType().slice()}
                    lowerProductTypes={this.getEndProductType().slice(0)}
                    endProductTypesConfigurations={this.props.endProductTypesConfigurations.slice()}
                    upperIndex={this.state.upperIndex}
                    lowerIndex={this.state.lowerIndex}
                    lowerEndProductId={this.state.lowerProductTypesId}
                    upperEndProductId={this.state.upperProductTypesId}
                    onUpperEndProductChanged={this.handleEndProductUpper}
                    onLowerEndProductChanged={this.handleEndProductLower}
                    onUpperImplantCountChanged={
                      this.handleUpperImplantCountChanged
                    }
                    onLowerImplantCountChanged={
                      this.handleLowerImplantCountChanged
                    }
                    upperImplantCount={this.state.upperImplantCount}
                    lowerImplantCount={this.state.lowerImplantCount}
                    onActiveChanged={this.handleActiveTreatmentChanged}
                    treatments={treatments}
                    treatment={this.state.activeTreatment}
                    treatmentIndex={this.state.activeIndex}
                    onEdit={this.handleEditClicked}
                    treatmentPlan={this.props.treatmentPlan}
                    onDisableWagner={this.handleDisableWagner}
                    onExtraTreatment={this.handleExtraTreatmentClick}
                    wagnerItem={this.state.wagnerItem}
                    wagnerActive={this.state.wagnerActive}
                    onMatchButtonClick={this.handleMatch}
                  />
                </FieldWrapper>
              )}
              {hasTreatment && (
                <FieldWrapper>
                  <CustomInputComponent
                    onChange={this.handleDescriptionChanged}
                    multiline
                    fullWidth
                    label={
                      <FormattedMessage
                        {...GlobalMessages.descriptionOptional}
                      />
                    }
                    value={this.state.description}
                  />
                </FieldWrapper>
              )}
            </Content>
          </StepArrows>
        </ContentContainer>
        <DocumentOrderModal
          onClose={() => {
            this.setState({
              isExitWarningModalOpen: false,
            });
          }}
          title={
            <FormattedMessage
              {...GlobalMessages.dataNotSavedModalAppointmentTitle}
            />
          }
          isOpen={this.state.isExitWarningModalOpen}
          onConfirm={() => {
            this.setState({
              isExitWarningModalOpen: false,
            });
            history.push(`/patient/${this.props.patient.id}`);
          }}
          content={
            <FormattedMessage
              {...GlobalMessages.dataNotSavedModalAppointmentBody}
            />
          }
        />
      </>
    );
  }
}

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 1000px;
  margin-left: auto;
  margin-right: auto;
  padding: ${({ theme }) => theme.padding}rem;
  ${({ theme }) => theme.desktopLargeUp`
    flex-direction: row;
  `};
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: ${({ theme }) => theme.margin}rem;
  margin-bottom: ${({ theme }) => theme.margin}rem;
  max-width: 1000px;
  ${({ theme }) => theme.desktopLargeUp`
    width: 1000px;
  `};
`;

const mapStateToProps = createStructuredSelector({
  treatmentPlan: makeSelectTreatmentPlan(),
  treatmentLoading: makeSelectTreatmentLoading(),
  endProductTypesConfigurations: makeSelectEndProductTypesConfigurations(),
  endProductTypes: makeSelectEndProductTypes(),
});

function mapDispatchToProps(dispatch) {
  return {
    setEditing: editing => dispatch(setEditingTreatmentAction(editing)),
    deletePlannedTreatment: (treatment, callback) =>
      dispatch(deletePlannedTreatment(treatment, callback)),
    setTreatmentToPlan: treatment =>
      dispatch(setTreatmentToPlanAction(treatment)),
    saveTreatments: treatments => dispatch(saveTreatments(treatments)),
    createTreatmentPlan: (treatmentPlan, callback) =>
      dispatch(createTreatmentPlanAction(treatmentPlan, callback)),
    updateTreatmentPlan: (treatmentPlan, callback) =>
      dispatch(updateTreatmentPlanAction(treatmentPlan, callback)),
    getTreatmentPlan: patientId => dispatch(getTreatmentPlan(patientId)),
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

const withReducer = injectReducer({
  key: "newTreatmentTreatmentStep",
  reducer,
});

export default injectIntl(
  compose(
    withReducer,
    withConnect,
  )(NewTreatmentTreatmentStep),
);
